import MyApp from '../src/App';

// React entry point
MyApp();
